import { useRouter } from 'src/shared/hooks/useRouting';
import { useEffect } from 'react';
import { changeTabTitle } from 'src/shared/helpers/pagesHelpers';
import { useSelector } from 'react-redux';
import { getUrlConfigs } from 'src/redux/core/coreSelectors';
// Handle everything that relative to html page
export var Document = function (props) {
    var children = props.children;
    var url = useRouter().url;
    var urlConfig = useSelector(getUrlConfigs);
    useEffect(function () {
        if (urlConfig && urlConfig.realm) {
            changeTabTitle("".concat(urlConfig.realm, " - ").concat(urlConfig.env).toUpperCase());
        }
    }, [url, urlConfig]);
    return children;
};
